import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import MarkerObject, {
    MarkerLabel,
    MarkerSelectionOverlay,
} from "../objects/MarkerObject";
import type { MapLayerProps, MarkerMapObject } from "../types";

interface MarkersLayerProps extends MapLayerProps<MarkerMapObject> {
    detectedIds?: ReadonlySet<string>;
}

const MarkersLayer = ({
    id,
    items,
    selectedIds,
    detectedIds,
    onItemClick,
    onItemHover,
    onItemLeave,
}: MarkersLayerProps) => {
    const { items: layerItems, selectedItems } = useMapLayer({
        items,
        selectedIds,
    });
    const baseObjects = useMemo(
        () =>
            layerItems.map((item) => (
                <MarkerObject
                    key={item.id}
                    item={item}
                    layerId={id}
                    detected={detectedIds?.has(item.id) ?? false}
                    onItemClick={onItemClick}
                    onItemHover={onItemHover}
                    onItemLeave={onItemLeave}
                />
            )),
        [id, layerItems, detectedIds, onItemClick, onItemHover, onItemLeave],
    );
    const labels = useMemo(
        () =>
            layerItems.map((item) => <MarkerLabel key={item.id} item={item} />),
        [layerItems],
    );

    return (
        <pixiContainer label="markers-layer">
            {baseObjects}
            {selectedItems.map((item) => (
                <MarkerSelectionOverlay key={item.id} item={item} />
            ))}
            {labels}
        </pixiContainer>
    );
};

export default MarkersLayer;
